/* eslint-disable react/jsx-pascal-case */
import axios, { AxiosError } from "axios";
import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import icon_down_black from "../../../../Image/ic_down_black.png";
import Buy_Complete_Modal from "./Buy_Complete_Modal";
import Basic_Modal from "./Basic_Modal";

interface OptionProps {
  $select: boolean;
}

type props_data_type = {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
};

interface Buy_ModalProps {
  visible: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
  item: props_data_type | null | undefined;
  seq: number;
  load_productList?: () => Promise<void>; // 선택적 함수
  type: string;
}

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
const BackgroundArea = styled.div<{ $visible: boolean; $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  position: absolute;
  display: ${(props) => (props.$visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  transition: opacity 0.5s ease;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  z-index: 99;
`;
const ModalBox = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  background-color: white;
  color: #454545;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  animation: ${(props) => (props.$isOpen ? slideUp : slideDown)} 0.5s ease;
  color: #1d1d1d;
`;
const Title_Box = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
`;
const Exit_Btn = styled(Icon)`
  position: absolute;
  right: 30px;
  justify-self: flex-end;
  cursor: pointer;
`;
const BtnArea = styled(RowView)`
  border-width: 0px;
  width: 100%;
  padding: 0px;
  margin-top: 1.5rem;
  flex: 1;
  padding: 25px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 20px;
  font-family: var(--font-Pretendard-SemiBold);
  text-align: center;
  cursor: pointer;
  color: white;
  background: linear-gradient(90deg, #7955f0, #3209b9);
  &:disabled {
    cursor: not-allowed;
    background: linear-gradient(to bottom right, #f8f8f8, #f8f8f8);
    color: #8e8e8e;
  }
`;
const Content_Box = styled.div`
  width: 100%;
  padding: 0px 30px;
  display: flex;
  position: relative;
  align-items: flex-start;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 14px;
`;
const Item_Box = styled.div`
  background-color: #f8f8f8;
  border-radius: 8px;
  width: 100%;
  padding: 22px 16px;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  flex-direction: column;
  box-sizing: border-box;
  div.name {
  }
  div.price {
    display: flex;
    color: #ea2922;
    margin-top: 3px;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;

    div.num {
      color: #c6c6c6;
    }
  }
`;
const Option_Box = styled.div`
  box-sizing: border-box;
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: auto;
  margin-top: 30px;
  width: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;
const Option_List_Box = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
`;
const Option_Select = styled.select<OptionProps>`
  min-width: 92px;
  height: 50px;
  border-radius: 8px;
  border-style: solid;
  border-color: ${(props) => (props.$select ? "#EB003B" : "#c8c8c8")};
  background-color: ${(props) => (props.$select ? "#FFE9E8" : "white")};
  display: flex;
  padding: 10px 30px 10px 10px;
  box-sizing: border-box;
  color: ${(props) => (props.$select ? "#EB003B" : "#8e8e8e")};
  font-size: 16px;
  margin-right: 10px;
  outline: 0;
  /* 기본 화살표 제거 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* 커스텀 화살표 추가 */
  background-image: url(${icon_down_black});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
`;
const Reset_Btn = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border-color: #c8c8c8;
  border-style: solid;
  border-width: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const Count_Box = styled.div`
  margin-top: 30px;
  width: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;
const Count_Content_Box = styled.div`
  margin-top: 10px;
  flex-direction: row;
  display: flex;
  position: relative;
  justify-content: space-between;
`;
const Counter = styled.div`
  padding: 10px 16px;
  width: 45%;
  display: flex;
  position: relative;
  box-sizing: border-box;
  border-width: 1px;
  border-color: #f0f0f0;
  border-style: solid;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  color: #8e8e8e;
`;

const Total_Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: #f0f0f0;
  width: 30%;
  font-size: 14px;
  color: #c6c6c6;
  div.count {
    color: #ea2922;
    font-size: 24px;
  }
  div.count_text {
    color: black;
    font-size: 24px;
  }
`;

const Counter_Btn = styled(Icon)`
  cursor: pointer;
`;
type option_type2 = {
  option1: string[];
  option2: string[];
  options: {
    seq: number;
    product_seq: number;
    option1: string;
    option2: string;
    init_cnt: number;
    current_cnt: number;
  }[];
};

const Buy_Modal = (props: Buy_ModalProps) => {
  const { visible, handleModal } = props;
  const [isLoading, set_IsLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      handleModal(true); // 모달을 열 때 visible 상태 true
      product_option_info();
    } else {
      setTimeout(() => {
        handleModal(false); // 모달 닫기 애니메이션이 끝난 후 visible 상태 false
      }, 500); // 애니메이션 시간 0.5초 후에 처리
    }
    set_Count(0);
    Reset();
  }, [visible]);

  const closeModal = () => {
    handleModal(false);
  };

  const [option_data, set_Option_data] = useState<option_type2>();

  const [select_option, set_Select_Option] = useState("");
  const [select_option2, set_Select_Option2] = useState("");
  const [option_seq, set_Option_Seq] = useState<number>(0);
  const [count, set_Count] = useState(0);
  const [sold_out, set_Sold_Out] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    set_Select_Option(event.target.value); // 이벤트로부터 선택된 값을 설정
    set_Select_Option2("");

    if (option_data?.option2[0] === "") {
      const selectedItem = option_data?.options.find(
        (item) => item.option1 === event.target.value && item.option2 === ""
      );
      if (selectedItem) {
        set_Sold_Out(selectedItem.current_cnt === 0);
        set_Option_Seq(selectedItem.seq); // 선택된 product_seq를 option_num에 설정
      }
    } else {
      set_Option_Seq(0);
    }
  };

  const handleChange2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption2 = event.target.value;
    set_Select_Option2(selectedOption2); // 선택된 option2 설정

    // 선택한 option2에 해당하는 item의 product_seq를 option_num에 저장
    const selectedItem = option_data?.options.find(
      (item) =>
        item.option1 === select_option && item.option2 === selectedOption2
    );
    if (selectedItem) {
      set_Sold_Out(selectedItem.current_cnt === 0);
      set_Option_Seq(selectedItem.seq); // 선택된 product_seq를 option_num에 설정
    }
  };

  const Reset = () => {
    set_Select_Option("");
    set_Select_Option2("");
    set_Option_Seq(0);
  };

  const count_up = () => {
    set_Count(count + 1);
  };
  const count_down = () => {
    count > 0 && set_Count(count - 1);
  };

  // 옵션 정보 불러오기
  const product_option_info = () => {
    axios
      .get(url.Communication_url.product_option_info, {
        params: {
          product_seq: props.item?.seq,
        },
      })
      .then(function (response) {
        response.data.option1.length !== 0
          ? set_Option_data(response.data)
          : set_Option_data(undefined);
      })
      .catch(function (error) {
        // console.log("get_product_option_info error : ", error);
        set_Option_data(undefined);
      });
  };

  // 주문하기
  const buy = async () => {
    set_IsLoading(true);
    if (option_data !== undefined) {
      if (
        option_data.option1.length > 0 &&
        option_data.option1[0] !== "" &&
        select_option === ""
      ) {
        // alert("옵션을 선택해주세요.");
        set_Basic_Modal_text("옵션을 선택해주세요.");
        open_Basic_Modal();
        set_IsLoading(false);
        return;
      }
      if (
        option_data.option2.length > 0 &&
        option_data.option2[0] !== "" &&
        select_option2 === ""
      ) {
        // alert("옵션을 선택해주세요.");
        set_Basic_Modal_text("옵션을 선택해주세요.");
        open_Basic_Modal();
        set_IsLoading(false);
        return;
      }
    }
    if (count === 0) {
      // alert("수량을 선택해주세요.");
      set_Basic_Modal_text("수량을 선택해주세요.");
      open_Basic_Modal();
      set_IsLoading(false);
    } else {
      try {
        await api.post(url.Communication_url.order, {
          live_seq: props.item?.live_seq,
          product_seq: props.item?.seq,
          option_seq: props.item?.option_check === "y" ? option_seq : null,
          order_cnt: count,
        });

        handleBuyComp();
      } catch (err) {
        if (err instanceof AxiosError && err.response) {
          const errRes = err.response.data;
          // alert(errRes.message);
          set_Basic_Modal_text(errRes.message);
          open_Basic_Modal();
        }
        console.log(err);
      } finally {
        set_IsLoading(false);
        props.load_productList && props.load_productList();
      }
    }
  };

  // 완료 모달
  const [BuyCompModal, setBuyCompModal] = useState(false);
  const handleBuyComp = () => setBuyCompModal(!BuyCompModal);
  const [BasicModal, set_BasicModal] = useState(false);
  const open_Basic_Modal = () => set_BasicModal(!BasicModal);
  const [basic_modal_text, set_Basic_Modal_text] = useState("");

  return (
    <BackgroundArea $visible={visible} $isOpen={visible} translate="no">
      <ModalBox $isOpen={visible} onClick={(e: any) => e.stopPropagation()}>
        <Title_Box>
          <div>구매하기</div>
          <Exit_Btn
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title_Box>
        <Content_Box>
          <Item_Box>
            <div>{props.item?.name}</div>
            <div className="price">
              <div>{amountFormat(props.item?.price)}원</div>
              {props.item?.product_num !== null &&
                props.item?.product_num !== undefined && (
                  <div className="num" translate="no">
                    No.{props.item?.product_num}
                  </div>
                )}
            </div>
          </Item_Box>
          <div style={{ marginTop: 5 }}>
            *구매하기는 장바구니에 담는 개념이 아닙니다. 신중 구매 부탁드립니다.
          </div>
          <Option_Box
            style={props.item?.option_check !== "y" ? { display: "none" } : {}}
          >
            옵션
            <Option_List_Box>
              <Option_Select
                style={
                  option_data?.option1.length === 0 ||
                  option_data?.option1[0] === ""
                    ? { display: "none" }
                    : { display: "flex" }
                }
                value={select_option} // 첫 번째 옵션 선택 상태
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  handleChange(e)
                } // 첫 번째 옵션 핸들러
                $select={select_option !== ""}
              >
                <option value="">선택</option>
                {option_data?.option1.map((item, index) => {
                  return (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  );
                })}
              </Option_Select>
              <Option_Select
                style={
                  option_data?.option2.length === 0 ||
                  option_data?.option2[0] === ""
                    ? { display: "none" }
                    : { display: "flex" }
                }
                value={select_option2} // 첫 번째 옵션 선택 상태
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  handleChange2(e)
                } // 첫 번째 옵션 핸들러
                $select={select_option2 !== ""}
              >
                <option value="">선택</option>
                {option_data?.options.map((item, index) => {
                  if (item.option1 === select_option) {
                    return (
                      <option value={item.option2} key={index}>
                        {item.option2}
                      </option>
                    );
                  }
                })}
              </Option_Select>

              <Reset_Btn onClick={Reset}>
                <Icon src={require("../../../../Image/ic_reset_black.png")} />
              </Reset_Btn>
            </Option_List_Box>
          </Option_Box>
          <Count_Box>
            수량
            <Count_Content_Box>
              <Counter>
                <Counter_Btn
                  onClick={count_down}
                  src={require("../../../../Image/ic_minus_black.png")}
                />
                {count}
                <Counter_Btn
                  onClick={count_up}
                  src={require("../../../../Image/ic_plus_black.png")}
                />
              </Counter>
              <Total_Count>
                <div>총 수량</div>
                <RowView className="count_text">
                  <div className="count">{count}</div>개
                </RowView>
              </Total_Count>
            </Count_Content_Box>
          </Count_Box>
        </Content_Box>
        <BtnArea
          as="button"
          onClick={buy}
          disabled={isLoading === true || count === 0 || sold_out === true}
        >
          {sold_out ? (count > 0 ? "품절" : "구매하기") : "구매하기"}
        </BtnArea>
      </ModalBox>
      <Buy_Complete_Modal
        visible={BuyCompModal}
        handleModal={handleBuyComp}
        onClose={closeModal}
      />
      <Basic_Modal
        visible={BasicModal}
        handleModal={set_BasicModal}
        text={basic_modal_text}
        onClose={closeModal}
        type={props.type}
      />
    </BackgroundArea>
  );
};

export default Buy_Modal;
